import { httpClient } from "@/services/httpClient";
/**
 * GET the recipient's active Email purposes + current statuses. The backend resolves the page
 * language (and the catalogue label language) from the supplied locale hints + the contact snapshot,
 * and echoes the result in `resolvedLocale`.
 */
export async function getEmailPreferences(token, options) {
    const params = {};
    if (options?.selectedLocale) {
        params.selectedLocale = options.selectedLocale;
    }
    if (options?.fallbackLocale) {
        params.fallbackLocale = options.fallbackLocale;
    }
    const { data } = await httpClient.get(`/email-preferences/${token}`, {
        params: Object.keys(params).length > 0 ? params : undefined,
    });
    return data;
}
/** PUT the per-purpose changes (or a global opt-out). */
export async function updateEmailPreferences(token, payload) {
    await httpClient.put(`/email-preferences/${token}`, payload);
}
